import { useRef } from 'react';
import { Box, Button, Card, CardContent, Typography } from '@mui/material';
import NorthIcon from '@mui/icons-material/North';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import clsx from 'clsx';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../weather-future.scss';
import { SETTINGS_WINTER } from '../../../consts/slick-const';

export const Winter = ({ data }) => {
    const sliderWinter = useRef();
    const sliderSpeed = useRef();
    const handlerPrev = () => {
        sliderWinter.current.slickPrev();
    };
    const handlerNext = () => {
        sliderWinter.current.slickNext();
    };
    const handlerPrevSpeed = () => {
        sliderSpeed.current.slickPrev();
    };
    const handlerNextSpeed = () => {
        sliderSpeed.current.slickNext();
    };
    const backgroundColors = (value) =>
        (value <= 7) ? 'back-grey' :
            (8 <= value && value <= 14) ? 'back-orang' :
                (15 <= value && value <= 22) ? 'back-pink' :
                    (value > 22) ? 'back-red' : '';

    return (
        <div>
            <div className='weather-future_title-slick'>
                <h3 className='weather-future_title'>Вітер, м/с</h3>
                <div className='weather-future_slick-arrows'>
                    <Button
                        variant='contained'
                        sx={{
                            backgroundColor: '#6565f5',
                            '&:hover': { backgroundColor: '#4d4de9' }
                        }}
                        onClick={handlerPrev}>
                        <NavigateBeforeIcon />
                    </Button>
                    <Button
                        variant='contained'
                        sx={{
                            marginLeft: '6px',
                            backgroundColor: '#6565f5',
                            '&:hover': { backgroundColor: '#4d4de9' }
                        }}
                        onClick={handlerNext}>
                        <NavigateNextIcon />
                    </Button>
                </div>
            </div>
            <Slider {...SETTINGS_WINTER} ref={sliderWinter}>
                {data.map((winter, index) => (
                    <Card sx={{ margin: '0' }} key={index}>
                        <CardContent sx={{ padding: '6px', '&:last-child': { paddingBottom: '6px' } }}>
                            <Box sx={{ marginBottom: '6px', padding: '10px' }}>
                                <Typography variant='body2' sx={{ marginBottom: '4px', fontSize: '16px' }}>
                                    {winter[0][0] ? winter[0][0] : 0}
                                </Typography>
                                <Typography variant='body2' sx={{ fontSize: '16px' }}>
                                    {winter[0][1] ? winter[0][1] : 0}
                                </Typography>
                            </Box>
                            <Box sx={{ marginBottom: '6px' }}>
                                <NorthIcon sx={{ transform: `rotate(${winter[1]}deg)` }} />
                            </Box>
                            <Typography
                                variant='body2'
                                sx={{ fontWeight: 'bold', fontSize: '16px' }}
                                className={clsx(backgroundColors(winter[2]))}>
                                {winter[2] ? winter[2] : 0}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </Slider>
            <div className='weather-future_title-slick'>
                <h3 className='weather-future_title'>Пориви вітру дo, м/с</h3>
                <div className='weather-future_slick-arrows'>
                    <Button
                        variant='contained'
                        sx={{
                            backgroundColor: '#6565f5',
                            '&:hover': { backgroundColor: '#4d4de9' }
                        }}
                        onClick={handlerPrevSpeed}>
                        <NavigateBeforeIcon />
                    </Button>
                    <Button
                        variant='contained'
                        sx={{
                            marginLeft: '6px',
                            backgroundColor: '#6565f5',
                            '&:hover': { backgroundColor: '#4d4de9' }
                        }}
                        onClick={handlerNextSpeed}>
                        <NavigateNextIcon />
                    </Button>
                </div>
            </div>
            <Slider {...SETTINGS_WINTER} ref={sliderSpeed}>
                {data.map((winter, index) => (
                    <Card key={index} sx={{ borderRadius: '4px 4px 0 0' }} >
                        <CardContent sx={{ padding: 0, '&:last-child': { paddingBottom: 0 } }}>
                            <Box sx={{ marginBottom: '6px', padding: '16px' }}>
                                <Typography variant='body2' sx={{ marginBottom: '4px', fontSize: '16px' }}>
                                    {winter[0][0] ? winter[0][0] : 0}
                                </Typography>
                                <Typography variant='body2' sx={{ fontSize: '16px' }}>
                                    {winter[0][1] ? winter[0][1] : 0}
                                </Typography>
                            </Box>
                            <Typography
                                variant='body2'
                                sx={{ paddingTop: '4px', fontWeight: 'bold', fontSize: '16px' }}
                                className={clsx(backgroundColors(winter[3]))}>
                                {winter[3] ? winter[3] : 0}
                            </Typography>
                        </CardContent>
                    </Card>
                ))}
            </Slider>
        </div>
    )
}